// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PreferredProviderDetails-preferredProviderCard-_lo2h {
    border-radius: 4px;
    border: 1px solid var(--primary-border);
    padding: 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 12px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.PreferredProviderDetails-preferredProviderCard-_lo2h:last-child {
    margin-bottom: 0;
}

.PreferredProviderDetails-preferredProviderCardInnerFlex-iBVD6 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 18px;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

.PreferredProviderDetails-preferredProviderImageWrapper-qfmWF {
    width: 54px;
    height: 54px;
    border-radius: 6px;
    overflow: hidden;
}

.PreferredProviderDetails-preferredProviderImageWrapper-qfmWF img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
}

.PreferredProviderDetails-providerName-xquEq {
    font-size: 14px;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 3px;
}

.PreferredProviderDetails-providerRatingWrapper-bKe6A {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 6px;
    margin-bottom: 3px;
    height: 12px;
}

.PreferredProviderDetails-providerServiceCount-M56I5 {
    font-size: 14px;
    line-height: 24px;
    margin: 0;
}

.PreferredProviderDetails-providerButtonWrapper-MHxys {
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.PreferredProviderDetails-removeLinkButton-qI5s4{
    background-color: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    font-size: 14px !important;
    line-height: 24px !important;
    font-weight: 700 !important;

}

@media screen and (max-width:500px) {
    .PreferredProviderDetails-preferredProviderCardInnerFlex-iBVD6 {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-pack: start;
            -ms-flex-pack: start;
                justify-content: flex-start;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PreferredProviderForm/PrefferedProviderDetails/PreferredProviderDetails.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,oBAAc;QAAd,cAAc;AAClB;;AACA;IACI,wCAAwC;IACxC,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;;AAE/B;;AACA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,uBAA2B;YAA3B,oBAA2B;gBAA3B,2BAA2B;QAC3B,wBAAuB;YAAvB,qBAAuB;gBAAvB,uBAAuB;IAC3B;AACJ","sourcesContent":[".preferredProviderCard {\n    border-radius: 4px;\n    border: 1px solid var(--primary-border);\n    padding: 12px;\n    display: flex;\n    gap: 12px;\n    align-items: flex-start;\n}\n\n.preferredProviderCard:last-child {\n    margin-bottom: 0;\n}\n\n.preferredProviderCardInnerFlex {\n    display: flex;\n    gap: 18px;\n    justify-content: space-between;\n    align-items: center;\n    flex-grow: 1;\n}\n\n.preferredProviderImageWrapper {\n    width: 54px;\n    height: 54px;\n    border-radius: 6px;\n    overflow: hidden;\n}\n\n.preferredProviderImageWrapper img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.providerName {\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 700;\n    margin-bottom: 3px;\n}\n\n.providerRatingWrapper {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 3px;\n    height: 12px;\n}\n\n.providerServiceCount {\n    font-size: 14px;\n    line-height: 24px;\n    margin: 0;\n}\n\n.providerButtonWrapper {\n    flex-shrink: 0;\n}\n.removeLinkButton{\n    background-color: transparent !important;\n    border: none !important;\n    border-radius: 0 !important;\n    font-size: 14px !important;\n    line-height: 24px !important;\n    font-weight: 700 !important;\n\n}\n@media screen and (max-width:500px) {\n    .preferredProviderCardInnerFlex {\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: flex-start;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preferredProviderCard": `PreferredProviderDetails-preferredProviderCard-_lo2h`,
	"preferredProviderCardInnerFlex": `PreferredProviderDetails-preferredProviderCardInnerFlex-iBVD6`,
	"preferredProviderImageWrapper": `PreferredProviderDetails-preferredProviderImageWrapper-qfmWF`,
	"providerName": `PreferredProviderDetails-providerName-xquEq`,
	"providerRatingWrapper": `PreferredProviderDetails-providerRatingWrapper-bKe6A`,
	"providerServiceCount": `PreferredProviderDetails-providerServiceCount-M56I5`,
	"providerButtonWrapper": `PreferredProviderDetails-providerButtonWrapper-MHxys`,
	"removeLinkButton": `PreferredProviderDetails-removeLinkButton-qI5s4`
};
module.exports = ___CSS_LOADER_EXPORT___;
